"use client";

import { SheetHeader, SheetTitle, SheetClose } from "@/components/ui/sheet";
import { Icon } from "@/components/ui/icon";
import { FOCUS_RING } from "./icon-button";

interface PresetSheetHeaderProps {
  title: string;
}
export function PresetSheetHeader({ title }: PresetSheetHeaderProps) {
  return (
    <SheetHeader>
      <div className="flex min-w-0 flex-wrap items-center gap-1.5">
        <Icon
          name="IconLayoutDashboard"
          size={18}
          aria-hidden="true"
          className="shrink-0 text-heading"
        />
        <SheetTitle>{title}</SheetTitle>
        <button
          type="button"
          aria-label="Learn more about presets (opens in new tab)"
          className={`relative ml-1 flex cursor-pointer items-center gap-1 rounded border border-contrast/[0.15] bg-contrast/4 px-1.5 py-0.5 text-[11px] font-medium text-heading shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] transition-colors hover:bg-contrast/8 ${FOCUS_RING}`}
        >
          <span>Learn More</span>
          <Icon
            name="IconSquareArrowTopRight2"
            size={12}
            aria-hidden="true"
            className="text-heading opacity-60"
          />
          <span
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 rounded-[inherit] shadow-[inset_0px_-1px_0px_0px_rgba(0,0,0,0.08)]"
          />
        </button>
      </div>
      <SheetClose />
    </SheetHeader>
  );
}
